import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function PricingFaq({ faqs }) {
  return (
    <Accordion type="single" collapsible className="space-y-4" data-testid="pricing-faq">
      {faqs.map((item, idx) => (
        <AccordionItem
          key={item.q}
          value={`item-${idx}`}
          className="bg-gray-900/50 border border-gray-800 rounded-xl px-6"
        >
          <AccordionTrigger className="text-white hover:text-cyan-400 text-left">
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="text-gray-400">{item.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
